// extracted by mini-css-extract-plugin
export default {"list":"RhymesPage_list__xwldu","node":"RhymesPage_node__NXUH1"};